import {fontWeights, fonts} from 'constants/fonts';
import { TextStyle } from 'react-native';
/**
 * The various styles of fonts are defined in the <Text /> component.
 *
 * How to add font:
 * Run the command: npx react-native link
 *
 * This will add the fonts in this directory to the native iOS and Android projects.
 * Ensure the path to this directory at react-native.config.js is correct.
 */

export const typography: Record<string, TextStyle> = {
  /**
   * The primary font used for paragraphs, body text, and details.
   */
  primary: {...fonts.source_sans_3},
  /**
   * The main header font (e.g., page titles).
   */
  header: {...fonts.inter, ...fontWeights.semi_bold},

  /**
   * The secondary header font (e.g., subheadings, section titles, , table headers).
   */
secondaryHeader: {...fonts.inter, ...fontWeights.medium},
};
